import React from 'react';
import BlankModal from '../../../../../components/modals/BlankModal';
import { dateFormaterWithTime } from '../../../../../helpers/formatters';
import RichTextDisplay from '../../../../../components/textEditor/RichTextDisplay';
import { classNames } from '../../../../../helpers/classNames';
import { BsBoxArrowInUpRight } from 'react-icons/bs';
import useNav from '../../../../../hooks/useNav';
import Highlighter from 'react-highlight-words';

const ActivityDetailModal = ({ activity, open, onClose, query }) => {
    const nav = useNav();

    const activityColors = {
        'Signup Complete': 'text-green-600 bg-green-100',
        'Payment Failed': 'text-red-600 bg-red-100',
    };

    const thisColor = activityColors[activity?.type] || 'text-gray-800 bg-gray-100';

    // Prepare search words for highlighting
    const searchWords = query && query.trim() !== '' ?
        (Array.isArray(query) ? query : [query]) :
        [];

    if (!activity) return null;

    return (
        <BlankModal
            open={open}
            setOpen={() => onClose()}
        >
            {/* Top row - all main info in one row */}
            <div className="flex justify-between items-center mb-6">
                {/* Name and Household (4 cols) */}
                <div className="">
                    {searchWords.length > 0 && activity.user_name ? (
                        <h4 className="font-medium text-gray-900 truncate">
                            <Highlighter
                                highlightClassName="bg-yellow-200 text-yellow-900"
                                searchWords={searchWords}
                                autoEscape={true}
                                textToHighlight={activity.user_name}
                            />
                        </h4>
                    ) : (
                        <h4 className="font-medium text-gray-900 truncate">{activity.user_name}</h4>
                    )}
                    <button
                        onClick={() => {
                            onClose();
                            nav(`/crm/households/${activity.household_id}/advisor`);
                        }}
                        className="flex items-center text-sm text-blue-600 hover:text-blue-800 mt-1"
                    >
                        {searchWords.length > 0 && activity.household_name ? (
                            <span className="truncate">
                                <Highlighter
                                    highlightClassName="bg-yellow-200 text-yellow-900"
                                    searchWords={searchWords}
                                    autoEscape={true}
                                    textToHighlight={activity.household_name}
                                />
                            </span>
                        ) : (
                            <span className="truncate">{activity.household_name}</span>
                        )}
                        <BsBoxArrowInUpRight className="ml-1 h-3 w-3 flex-shrink-0" />
                    </button>
                </div>


                {/* Time (4 cols) */}
                <div className=" text-right">
                    <span className={classNames(thisColor, 'inline-flex items-center rounded-full px-3 mb-1 py-1 text-sm font-medium')}>
                        {activity.type}
                    </span>
                    <p className="text-sm text-gray-900">{dateFormaterWithTime(new Date(activity.created_at))}</p>
                </div>
            </div>

            {/* Details section */}
            <div className="border-t border-gray-200 pt-4">
                <p className="text-sm text-gray-500 mb-2">Details</p>
                <div className="bg-gray-50 rounded-lg p-4">
                    {activity.content ? (
                        <div className="text-base text-gray-800">
                            <RichTextDisplay content={activity.content} thisClassName={'notes'} query={query} />
                        </div>
                    ) : searchWords.length > 0 && activity.details ? (
                        <p className="text-base text-gray-800">
                            <Highlighter
                                highlightClassName="bg-yellow-200 text-yellow-900"
                                searchWords={searchWords}
                                autoEscape={true}
                                textToHighlight={activity.details}
                            />
                        </p>
                    ) : (
                        <p className="text-base text-gray-800">{activity.details || 'No details available'}</p>
                    )}
                </div>
            </div>
        </BlankModal>
    );
};

export default ActivityDetailModal; 